export default __webpack_public_path__ + "static/media/blob_green_4.49a9bc9d.svg";